import { APP_INITIALIZER, ApplicationConfig, inject, LOCALE_ID, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './auth/interceptors/auth-interceptor';
import { authErrorInterceptor } from './auth/interceptors/auth-error-interceptor';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr'
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { DatabaseConnection } from './shared/services/database-connection';


registerLocaleData(localeFr)

export const MY_DATE_FORMATS = {
  parse: { dateInput: 'DD/MM/YYYY' },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

  function initConnection(){
    return () => new Promise<void>((resolve) =>{
        const con = inject(DatabaseConnection)
        con.initConnection().then((res) =>{
            resolve()
        })
    })
  }

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideHttpClient(
      withInterceptors([authInterceptor, authErrorInterceptor]) // Ajoutez votre intercepteur ici
    ),
    provideCharts(withDefaultRegisterables()),
    provideMomentDateAdapter(MY_DATE_FORMATS),
    {provide : MAT_DATE_LOCALE, useValue:'fr-FR'},
    {provide : LOCALE_ID, useValue: 'fr-FR'},
    {provide : MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc : true}},
    {
      provide : APP_INITIALIZER,
      useFactory : initConnection,
      multi : true
    }
  ]
};
